import styled from 'styled-components'
import { Row, Col } from 'react-styled-flexboxgrid'
import { Input, Button } from '../index'
import variables from '../../styles/variables'

export const Container = styled.div`
  max-width: 100%;
  padding: 20px 0;
`

export const FormRow = styled(Row)`
  margin: 10px 0px;
`

export const FormCol = styled(Col)`
  display: flex !important;
  justify-content: center;

  @media ${variables.media.sm} {
    justify-content: left;
  }
`

export const ChartRow = styled(Row)`
  font-size: 0.8rem;
`

export const LinkText = styled.div`
  color: ${variables.colors.jade.medium};
  margin: 0 0 20px 10px;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`

export const Collapse = styled.div`
  max-height: ${props => (props.active ? '400px' : '0')};
  width: 100%;
  overflow: hidden;
  transition: all 0.5s ease;
  margin-bottom: 10px;
  margin-left: 10px;
`

export const SearchInput = styled(Input)`
  border: 1px solid gray;
`

export const SearchButton = styled(Button)`
`

export const Tooltip = styled(Row)`
  background-color: white;
  max-width: 300px;
  padding: 10px;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 2px 2px rgba(0, 0, 0, 0.2);
  font-size: 1rem;
`
